<template>
  <div class="pravo">
    <PravoTop Image="gameOverview" Header="Game overview" />

    <div class="pravo__obsah">
      <div class="grid">
        <SoldProducts TableWidth="twoThirds" />

        <TeamRanking TableWidth="oneThird" />

        <Campaigns TableWidth="twoThirds" />

        <FinancialOverview TableWidth="oneThird" />

        <PurchasedData TableWidth="twoThirds" />

        <TeamInfo TableWidth="oneThird" />
      </div>
    </div>
  </div>
</template>

<script>
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import TeamRanking from "@/components/game/table/tables/TeamRanking.vue";
import FinancialOverview from "@/components/game/table/tables/FinancialOverview.vue";
import SoldProducts from "@/components/game/table/tables/SoldProducts.vue";
import Campaigns from "@/components/game/table/tables/Campaigns.vue";
import PurchasedData from "@/components/game/table/tables/PurchasedData.vue";
import TeamInfo from "@/components/game/table/tables/TeamInfo.vue";

export default {
  name: "GameOverview",
  components: {
    PravoTop,
    TeamRanking,
    FinancialOverview,
    SoldProducts,
    Campaigns,
    PurchasedData,
    TeamInfo,
  },
};
</script>
